
<div>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12   document">


    <div class="card-header wh-header border-bottom padding-left-15px padding-right-15px padding-top-6px padding-bottom-6px">
      <div class="row" >
       
        <div class="col-md-1 padding-left-9px padding-right-0px">
          <img class="image-circle-small-test"  src='dummy.jpg'>
        </div>
        <div class="col-md-9 padding-left-0px">
          <label class="font-size-15px font-weight-normal margin-bottom-0px">Follicular Scan</label>
          <div class="line-height-2px">
            <label class="font-size-11px font-weight-normal margin-bottom-0px">Date:17-10-2019</label>
          </div>
        </div>
      
        <div class="col-md-2 margin-top-auto margin-bottom-auto">
          <button type="button" class="close float-right" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

      </div>



    </div>
  
    <div class="modal-body padding-top-0px counselling-modal">

      <div class="row margin-left-0px margin-top-15px">
        <div class="col-md-12">
          <div class="accordion margin-bottom-20px" id="accordionExample5">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                        Procedures/Tests
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-8 ">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button type="button"
                            class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" 
                            name="upload" hidden>
                      <i class="fas fa-plus font-size-11"></i>
                    </button>
                    <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                  </div>
                  <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                </div>


              </div>

              <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                  <div class="card margin-bottom-0px">
                    <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                    <div class="card-body padding-top-0px padding-bottom-0px">
                      <div class="row">
                        <div class="col-lg-11 col-md-11 col-xs-11 padding-right-0px">
                          <div class="table-component table-tests">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-50-new">
                                <thead>
                                  <tr>
                                    <th class="font-weight-normal  background-primary padding-left-4 padding-right-4  padding-right-0px th-width-40px padding-top-4px padding-bottom-4px"></th>
                                    <th class="font-weight-normal  background-primary padding-left-4  padding-left-0px padding-top-4px padding-bottom-4px">
                                      Test Name
                                    </th>
                                    <!--<th class="text-align-center">Day</th>-->
                                    <!--<th class="font-weight-normal  background-primary">
                                  Comments
                                </th>-->
                                    <!--<th class="text-align-center">Start Time</th>-->

                                    <th class="background-primary padding-top-4px padding-bottom-4px"></th>










                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr>
                                    <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                    <td class="padding-top-4px padding-bottom-4px padding-right-0px">1</td>
                                    <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                      <div class="height-16px">
                                        <label class="font-size-14 margin-bottom-0px color-medicine">Follicular</label>
                                      </div>
                                      <div class="row-height-17px">
                                        <label class="font-size-12px margin-bottom-0px color-medicine">Normal</label>
                                      </div>
                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px">
                                      <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                  </a>-->
                                      <div class="test-icons">
                                        <a title="Remove"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                        <!--<a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit">
                                      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                    </a>-->
                                      </div>
                                    </td>




                                  </tr>

                                </tbody>
                              </table>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row margin-left-0px margin-top-15px">
        <div class="col-md-12">
          <div class="accordion margin-bottom-20px" id="accordionExample6">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSix">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                        Medicines
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-8 ">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button type="button"
                            class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" 
                            name="upload" hidden>
                      <i class="fas fa-plus font-size-11"></i>
                    </button>
                    <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                  </div>
                  <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                </div>


              </div>

              <div id="collapseSix" class="collapse show" aria-labelledby="headingSix" data-parent="#accordionExample6">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                  <div class="card margin-bottom-0px">
                    <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                      <div class="col-lg-11 col-md-11 col-xs-11 col-11 padding-right-0px ">


                        <div class="table-component">
                          <div class="table-responsive">


                            <table class="table table-striped margin-left-zero width-50-new">
                              <thead>
                                <tr>
                                  <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                  <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">
                                    Medicine Name
                                  </th>
                                  <!--<th class="text-align-center">Day</th>-->
                                  <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">
                                    Dose
                                  </th>
                                  <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">
                                    Dosage Form
                                  </th>
                                  <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">
                                    Instructions
                                  </th>


                                  <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                  </th>
                                  <!--<th class="text-align-center">Start Time</th>-->
                                  <!--<th></th>-->










                                </tr>
                              </thead>
                              <tbody class="table-body">

                                <tr>
                                  <td class="padding-top-4px padding-bottom-4px ">1</td>
                                  <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                <div class="height-16px" >
                                  <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
                                </div>

                              </td>-->
                                  <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">Gonal-F</label></td>
                                  <td class=" padding-top-4px padding-bottom-4px padding-right-6px padding-left-6px">25Mg</td>
                                  <td class=" padding-top-4px padding-bottom-4px padding-left-4">Oral</td>
                                  <td class=" padding-top-4px padding-bottom-4px padding-right-6px">normal</td>

                                  <td class="padding-top-4px padding-bottom-4px ">
                                    <div class="test-icons">
                                      <a class="float-right" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                      <!--<a (click)="EditMedicine()" class="nav-link-hand education-navlink  color-Assign" title="Edit">
                                    <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                  </a>-->
                                    </div>
                                  </td>
                                  <!--<td class="padding-top-4px padding-bottom-4px">


                              </td>-->




                                </tr>

                              </tbody>
                            </table>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!--<div class="row float-right">
        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px" (click)="activeModal.close('Close click')">Cancel</button>
       
      </div>-->

    </div>
   
    <div class="modal-footer padding-top-8px padding-bottom-8px padding-left-8px padding-right-8px">
      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px" (click)="activeModal.close('Close click')">Cancel</button>
    </div>
  </div>
</div>
